import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { EMPTY, catchError } from 'rxjs';
import { DocumentApiService } from '../services/document.api.service';
import { DocumentRowData } from '../../documents/types/documents.type';
import { inject } from '@angular/core';

export const documentResolver: ResolveFn<DocumentRowData> = (route: ActivatedRouteSnapshot) => {
  const documentService = inject(DocumentApiService);
  const router = inject(Router);

  const id = route.paramMap.get('id');

  if (!id) {
    void router.navigate(['/documents']);
    return EMPTY;
  }

  return documentService.getDocumentById(id).pipe(
    catchError(() => {
      void router.navigate(['/documents']);
      return EMPTY;
    })
  );
};
